<style lang="less" scoped>
.zlkListDouble{position: relative;margin-left: -36px;margin-top: 20px;}
ul{list-style: none;}
</style>

<template>
  <div class="zlkListDouble">
    <ul>
      <li v-for="(item,index) in List" :key="index">
        <ListDouble class="listDouble" :listDouble="item" @getmore="goList" @clickList="goDetails"></ListDouble>
      </li>
    </ul>
  </div>
</template>

<script>
/**
 * 何宽 资料库首页第三级分类内容页面
 */
import ListDouble from '../assembly/ListDouble.vue'
export default {
  components: {
    ListDouble
  },
  data()
  {
    return {
      Cate: [],
      List: []
    }
  },
  watch:
  {
    $route:
    {
      handler(nval, oval)
      {
        if (nval.query.catid)
          this.getCategory(+nval.query.catid)
      },
      immediate: true
    }
  },
  methods: {
    // 根据catid，从dmcn_values获取当前在页面展示的分类
    getCategory(num)
    {
      let paras = {cmd: 'query', _major: 99, _minor: 20, _exp: `moduleid=31 and glid=${num}`}
      window.post.getPost(paras).then((ret) =>
      {
        this.Cate = []
        ret.forEach(item => this.Cate.push({catid: item.id, type: item.dispc}))

        this.List = []
        this.Cate.forEach(item => this.getListdata(item))
      })
    },
    // 根据catid，从dmcn_article_103获取当前需要展示的列表数据
    getListdata(item)
    {
      let paras = {cmd: 'query', _major: 11, _minor: 24, _exp: `catid=${item.catid} and examine = 0`, orderby: 'addtime DESC', init: 0, pageno: 1, pagesize: 10}
      window.post.getPost(paras).then((ret) =>
      {
        this.List.push({type: item.type, button: '更多', catid: item.catid, listdata: ret[0].data})
      })
    },
    // 跳转到矿业资讯列表页面，并将被点击的对象的catid传递过去
    goList(item)
    {
      let url = this.$router.resolve({path: '/ZlkList', query: {catid: item.catid}})
      window.open(url.href, '_blank')
    },
    // 跳转到矿业资讯详情页面，并将被点击的对象的id传递过去
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/ZlkDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/ZlkListDouble.vue